(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dani-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dani-shipping-popup')) {
    customElements.define('dani-shipping-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.storageKey = `dani-shipping-popup:${this.dataset.sectionId}`;
        this.editor = Boolean(window.Shopify && window.Shopify.designMode);

        this.querySelector('[data-popup-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-popup-shop]')?.addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right ||
              event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        }, options);

        if (this.editor) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.openPopup();
          }, options);
          document.addEventListener('shopify:section:deselect', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
          }, options);
          this.timer = setTimeout(() => this.openPopup(), 0);
          return;
        }

        try {
          if (this.dataset.frequency === 'session' && sessionStorage.getItem(this.storageKey)) return;
        } catch (error) { /* Still show the offer if browser storage is unavailable. */ }

        this.timer = setTimeout(() => this.openPopup(), Number(this.dataset.delay) * 1000);
      }

      openPopup() {
        if (!this.isConnected || this.dialog.open) return;
        // Wait until the tab is visible and any other native modal has closed.
        if (document.hidden || document.querySelector('dialog[open]')) {
          this.timer = setTimeout(() => this.openPopup(), 1000);
          return;
        }
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        if (!this.editor && this.dataset.frequency === 'session') {
          try { sessionStorage.setItem(this.storageKey, 'shown'); }
          catch (error) { /* Browser storage can be disabled. */ }
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
